import { createContext } from 'react'
import type { NewNotificationInput, Notification } from '../../types/notifications'

export interface NotificationContextValue {
  notifications: Notification[]
  unreadCount: number
  add: (input: NewNotificationInput) => Notification
  markRead: (id: string) => void
  markAllRead: () => void
  remove: (id: string) => void
  clear: () => void
}

export const NotificationContext = createContext<NotificationContextValue | undefined>(undefined)
